module.exports = __webpack_public_path__ + "img/telegram_chat_purchases.f951869d.png";